export const PL: Record<string, string> = {
  "Recommended for you": "Zalecane dla Ciebie",
  "Resource added to favorite": "Zasób dodany do ulubionych",
  "Failed to add resource to favorite": "Nie udało się dodać zasobu do ulubionych",
  "Resource removed from favorite": "Zasób usunięty z ulubionych",
  "Failed to remove resource from favorite": "Nie udało się usunąć zasobu z ulubionych",
  "Calendar": "Kalendarz",
  "View Detail": "Zobacz szczegóły",
  "Add to favorites": "Dodaj do ulubionych",
  "Remove from favorites": "Usuń z ulubionych",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Opis: Sala konferencyjna VIP z wspaniałym widokiem i wygodnymi krzesłami.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "W wybranym czasie w Twojej lokalizacji lub w ulubionych nie ma dostępnych zasobów.",
  "You have these options:": "Masz następujące opcje:",
  "Change the meeting time.": "Zmień czas spotkania.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Użyj przycisku <1>Znajdź dostępny czas</1>, aby wybrać nowy czas.",
  "Open the search to find other resources.": "Otwórz wyszukiwanie, aby znaleźć inne zasoby.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "Typ zasobu <1>'{{resourceType}}'</1> nie istnieje na Twojej domyślnej lokalizacji",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "Typ zasobu <1>'{{resourceType}}'</1> można znaleźć na innej lokalizacji.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Kliknij tutaj</1>, aby dodać typ zasobu do ustawień domyślnej lokalizacji.",
  
  // ResourceCard
  "New Order": "Nowe zamówienie",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Podczas rezerwacji zasobu grupowego można rezerwować tylko ten typ zasobu i tylko jeden zasób.",
  "You cannot select both a child resource and its virtual resource at the same time.": "Nie możesz wybrać zarówno zasobu dziecka, jak i jego zasobu wirtualnego jednocześnie.",
  // Settings
  "Note:": "Uwaga:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "Asystent organizatora może otrzymywać te same wiadomości e-mail z Resource Central co organizator i może obsługiwać zamówienia w imieniu organizatora.",
  "Setting updated successfully": "Ustawienie zaktualizowane pomyślnie",
  "Setting updated failed": "Aktualizacja ustawienia nie powiodła się",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 miejsce",
  "Opening hours:": "Godziny otwarcia:",
  "Buffer time {{minutes}} mins between reservations": "Czas buforowy {{minutes}} min między rezerwacjami",
  "Initial payment {{value}} pr.minute": "Płatność początkowa {{value}} za minutę",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Łącznie {{total}} uczestników",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} z {{total}} wewnętrznych może uczestniczyć.",
  "{{external}} external is unknown.": "{{external}} zewnętrznych jest nieznanych.",
  "Find available time": "Znajdź dostępny czas",
  "Attendees": "Uczestnicy",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Kliknij Więcej informacji, aby odwiedzić naszą stronę wsparcia",
  "Further information": "Więcej informacji",
  
  // LocationSetting
  "Location changed": "Lokalizacja zmieniona",
  "Location change failed": "Zmiana lokalizacji nie powiodła się",
  "Please select at least one location": "Wybierz co najmniej jedną lokalizację",
  "Resource types": "Typy zasobów",
  "Location": "Lokalizacja",
  "Where": "Gdzie",
  
  // ModalShowAttendees
  "Total": "Łącznie",
  "Available": "Dostępny",
  "Busy": "Zajęty",
  "External": "Zewnętrzny",
  "Internal": "Wewnętrzny",
  
  // ResourceSearch
  "Search by resource name": "Wyszukaj według nazwy zasobu",
  "Category": "Kategoria",
  "Filter by Location": "Filtruj według lokalizacji",
  "Filter by Category": "Filtruj według kategorii",
  "Capacity": "Pojemność",
  "Filter by Capacity": "Filtruj według pojemności",
  "All": "Wszystkie",
  "Filter by availability": "Filtruj według dostępności",
  "Sort By": "Sortuj według",
  "Loading...": "Ładowanie...",
  
  // SelectedResources
  "Meeting Type": "Typ spotkania",
  "Meeting Label": "Etykieta spotkania",
  
  // Alert (accessibility text)
  "Check icon": "Ikona zaznaczenia",
  "Close": "Zamknij",
  
  // AppConstants - searchTab
  "Resource": "Zasób",
  "Person": "Osoba",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Gdzie zwykle odbywają się Twoje spotkania?",
  "To improve our recommendations for you we would like you to enter your normal location": "Aby poprawić nasze rekomendacje dla Ciebie, chcielibyśmy, abyś podał swoją zwykłą lokalizację",
  "What do you use most?": "Z czego korzystasz najczęściej?",
  "To enable quicker and better search please chose you prefered resource type": "Aby umożliwić szybsze i lepsze wyszukiwanie, wybierz preferowany typ zasobu",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Kliknij zasób, aby wybrać",
  "Selected Resources": "Wybrane zasoby",
  "Setting": "Ustawienie",
  "Search": "Szukaj",
  "Find Colleague": "Znajdź kolegę",
  "Quick button setting": "Ustawienie przycisku szybkiego",
  "Favorite": "Ulubione",
  "Most Used": "Najczęściej używane",
  "Colleagues": "Koledzy",
  "Resources": "Zasoby",
  
  // AppConstants - tooltipText
  "Back": "Wstecz",
  "Floor Plan": "Plan piętra",
  "Expand": "Rozwiń",
  "Selected resources": "Wybrane zasoby",
  "View details": "Zobacz szczegóły",
  "Remove from My Favorites": "Usuń z moich ulubionych",
  "Add to My Favorites": "Dodaj do moich ulubionych",
  "Remove": "Usuń",
  "Favorite - Most Used": "Ulubione - Najczęściej używane",
  "Conflict": "Konflikt",
  "Approved": "Zatwierdzony",
  "Recommendeded for you": "Zalecane dla Ciebie",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Tylko główny organizator",
  "Only assistant organizer": "Tylko asystent organizatora",
  "Primary AND assistant organizer": "Główny I asystent organizatora",
  
  // FindColleague
  "Enter colleague name": "Wprowadź nazwisko kolegi",
  "Recent work items": "Ostatnie elementy robocze",
  "No data available": "Brak dostępnych danych",
  "Floorplan": "Plan piętra",
  "List nearby resources": "Lista zasobów w pobliżu",
  "Find resource nearby": "Znajdź zasób w pobliżu",
  "No Resources available": "Brak dostępnych zasobów",
  
  // Start page
  "Next": "Dalej",
  "Failed to update default locations": "Nie udało się zaktualizować domyślnych lokalizacji",
  "Resource Type": "Typ zasobu",
  
  // QuickSetting
  "Quick buttons updated successfully": "Przyciski szybkie zaktualizowane pomyślnie",
  "Quick buttons updated failed": "Aktualizacja przycisków szybkich nie powiodła się",
  "Add more": "Dodaj więcej",
  "Apply": "Zastosuj",
  "Delete": "Usuń",
  "Name": "Nazwa",
  "Enter name": "Wprowadź nazwę",
  "Tooltip": "Podpowiedź",
  "Enter tooltip": "Wprowadź podpowiedź",
  "Type": "Typ",
  "Select type": "Wybierz typ",
  "Locations": "Lokalizacje",
  "Select colleagues": "Wybierz kolegów",
  "Select resources": "Wybierz zasoby",
  
  // DefaultResourceSetting
  "Resource type changed": "Typ zasobu zmieniony",
  "Resource type change failed": "Zmiana typu zasobu nie powiodła się",
  "Default Resource Type": "Domyślny typ zasobu",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Zastosowano pomyślnie",
  "Apply Failed": "Zastosowanie nie powiodło się",
  "Assistant Organizer": "Asystent organizatora",
  "Enter a part of the name to search for": "Wprowadź część nazwy do wyszukania",
  "Mail Flow": "Przepływ poczty",
  "Select Mail Flow": "Wybierz przepływ poczty",
  
  // TileConfigurationSetting
  "Update settings successfully": "Ustawienia zaktualizowane pomyślnie",
  "Update settings failed": "Aktualizacja ustawień nie powiodła się",
  "Timeline": "Oś czasu",
  
  // SelectCategoryForm
  "And": "I",
  "Or": "Lub",
  
  // Other
  "Resource Calendar": "Kalendarz zasobów",
  
  // SettingLabels
  "Default Location": "Domyślna lokalizacja",
  "Quick button": "Przycisk szybki",
  "Category icons": "Ikony kategorii",
  "Recommendation screen": "Ekran rekomendacji",
  "Capacity filter": "Filtr pojemności",
  "AI Assistant": "Asystent AI",
  "Tile configuration": "Konfiguracja kafelków",
  "Help": "Pomoc",
  "Default Categories": "Domyślne kategorie",
  
  // MeetingType
  "Your must select a Meeting label": "Musisz wybrać etykietę spotkania",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Wybrany zasób: 'AOD_Copanhagen' Konfliktowe wystąpienia",
  "Alternative Resource": "Alternatywny zasób",
  "OK": "OK",
  "Cancel": "Anuluj",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Twój wybrany zasób 'AOD_Copenhagen' został usunięty",
  "You can't book this resource as your request exceeds the available capacity.": "Nie możesz zarezerwować tego zasobu, ponieważ Twoje żądanie przekracza dostępną pojemność.",
  
  // ChangeTime
  "Time changed successfully": "Czas zmieniony pomyślnie",
  "Current Time": "Aktualny czas",
  "Suggested Times": "Sugerowane czasy",
  "Change Time": "Zmień czas",
  "people are free": "osób jest wolnych",
};

